<template>
  <div>
    <div  class="condition-group mb-2"  v-for="(group, index) in value"  :key="index" >
      <b-row>
        <b-col md="6">
      <b-form-group class="">
        <multiselect v-model="group.operator"  label="text" track-by="value" :options="groupOptions" :allow-empty="false" :custom-label="customLabel" :show-labels="false">
          <template slot="singleLabel" slot-scope="props"><span v-html="props.option.text"></span></template>
          <template slot="option" slot-scope="props"><span v-html="props.option.text"></span>
          </template>
        </multiselect>
      </b-form-group>
      </b-col>
      </b-row>
      <div  class="condition mb-2" v-for="(cond, ind) in group.conditions"  :key="ind" >
        <condition v-if="!removing" :key="recipienttype" :recipienttype="recipienttype" v-model="value[index].conditions[ind]" :regions="regions" :membertypes="membertypes" :activities="activities" v-on:updated-condition="updatedCondition" v-on:remove-condition="removeCondition(index, ind)"></condition>
      </div>
      <b-btn variant="primary" class="mt-1" size="xs" @click="addRecipientsCondition(index)"><i class="fa fa-plus"></i> condição</b-btn>
      <b-btn variant="danger" class="mt-1 pull-right" size="xs" @click="removeGroup(index)"><i class="fa fa-times"></i> grupo de condições</b-btn>
    </div>
    <b-btn variant="primary" class="mt-1" size="xs" @click="addRecipientsGroup"><i class="fa fa-plus"></i> grupo de condições</b-btn>
</div>
</template>
<script>
import Condition from './condition.vue'
import Multiselect from 'vue-multiselect'
import Lists from '@/components/Lists.js'
import 'vue-multiselect/dist/vue-multiselect.min.css'
export default {
  name: "ConditionsForm",
  components: { Condition , Multiselect},
  props: {
    value: {
      type: Array,
      required: true,
    },
    recipienttype: {
      type: Number
    },
    regions: {
      type: Array
    },
    activities: {
      type: Array
    },
    membertypes: {
      type: Array
    }
  },
  data() {
    return {
      removing: false,
      groupOptions: Lists.campaigns.recipientConditionsOperator
    }
  },
  watch: {
    value() {
      this.$emit("input", this.value);
    },
  },
  computed: {
  },
  methods: {
    customLabel ({ title, desc }) {
      return `${title} – ${desc}`
    },
    removeGroup(group, condition) {
      this.value.splice(group,1 )
    },
    updatedCondition() {
      console.log('conditions component: changed conditions')
      this.$emit('updated-conditions')
    },
    removeCondition(group, condition) {
      this.removing = true
      console.log('removing from group ', group)
      console.log('condition ', condition)
      this.value[group].conditions.splice(condition, 1)
      var that = this
      setTimeout(function() {
        that.removing = false
      })
    },
    addRecipientsCondition(index) {
      this.value[index].conditions.push({type: null, values: [] })
    },
    addRecipientsGroup() {
      this.value.push({
        operator: 'and',
        conditions: [{type: null, values: []}]
      })
    },
    validateState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },
  }
};
</script>
